'use client';

import { useSession } from '@/providers/session-provider';

// A product decision rather than a data one: the feed reads event logs and
// detailed logs, but is offered to admins who fully manage monitoring.
export const SYSTEM_ACTIVITY_PERMISSION_MODEL = 'monitoringconfiguration';

export function useCanUseSystemActivity() {
  const {
    data: { user },
  } = useSession();
  const perms = user.permissions[SYSTEM_ACTIVITY_PERMISSION_MODEL]?.overall;
  return (
    user.detailAccess === 0 &&
    !!perms?.canView &&
    !!perms.canCreate &&
    !!perms.canUpdate &&
    !!perms.canDelete
  );
}
